export const requiredRule = {
  required: true,
  message: "Esse campo é obrigatório",
};
